import { push } from "connected-react-router"
import { getActiveLanguage } from "react-localize-redux"
import { startSubmit } from "redux-form"
import jwtDecode from "jwt-decode"

import apiClient from "../../helpers/apiClient"
import { createLoadingSelector } from "./Loading"
import {
	setCookie,
	deleteCookie,
	getCookie,
	stringToBoolean,
	setTokenCookie,
	getClientIp,
	formatAntiFraudDate,
	getDevicePayload,
} from "../../helpers"
import { JWT_TOKEN, NO_OF_TRIES, VERIFY_GOLD_CARD_ADDRESS } from "../../constants"
import { getToken } from "./XsrfToken"
import { ANTI_FRAUD } from "../../constants/antiFraud"

export const LOGIN = "LOGIN"
export const LOGIN_REQUEST = "LOGIN_REQUEST"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAILURE = "LOGIN_FAILURE"

export const LOGOUT = "LOGOUT"
export const LOGOUT_REQUEST = "LOGOUT_REQUEST"
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS"
export const LOGOUT_FAILURE = "LOGOUT_FAILURE"

export const REFRESH_TOKEN = "REFRESH_TOKEN"
export const REFRESH_TOKEN_REQUEST = "REFRESH_TOKEN_REQUEST"
export const REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS"
export const REFRESH_TOKEN_FAILURE = "REFRESH_TOKEN_FAILURE"

export const SET_KEEP_LOGIN = "SET_KEEP_LOGIN"

export const CSO_LOGIN = "CSO_LOGIN"
export const CSO_LOGIN_REQUEST = "CSO_LOGIN_REQUEST"
export const CSO_LOGIN_SUCCESS = "CSO_LOGIN_SUCCESS"
export const CSO_LOGIN_FAILURE = "CSO_LOGIN_FAILURE"

const GOTO_ADD_CARD = "GOTO_ADD_CARD"

const cookieToken = getCookie(JWT_TOKEN)
const cookieNoOfTries = getCookie(NO_OF_TRIES)
const userCk = cookieToken ? jwtDecode(cookieToken) : null

const initialState = {
	isAuthenticated: cookieToken ? true : false,
	noOfTries: cookieNoOfTries ? parseInt(cookieNoOfTries, 10) : 0,
	token: cookieToken,
	keepLogin: userCk && stringToBoolean(userCk.keep_login),
	errorMessage: "",
	userInfoAutoFill: {
		email: userCk ? userCk.email : undefined,
		name: userCk ? userCk.given_name : undefined,
	},
}

const setKeepLogin = (value) => {
	return {
		type: SET_KEEP_LOGIN,
		payload: {
			keepLogin: stringToBoolean(value.keep_login),
			userInfoAutoFill: {
				email: value.email,
				name: value.given_name,
			},
		},
	}
}

const loadingLoginSelector = createLoadingSelector([LOGIN])
export const login = (values, formId) => (dispatch, getState) => {
	const isFetching = loadingLoginSelector(getState())
	if (!values || isFetching) return Promise.resolve()

	return Promise.resolve(dispatch(startSubmit(formId)))
		.then(() => dispatch(getToken()))
		.then(async () => {
			let deviceBlackBox = window.collector.getPayload(window._bcn.dvc.getTID())

			deviceBlackBox = JSON.stringify(deviceBlackBox)
			const clientIp = await getClientIp()

			return dispatch({
				types: [LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE],
				callAPI: (config) =>
					apiClient.post(
						`api/account/authenticate`,
						{
							...values,
							antiFraudData: {
								device: {
									endUserIp: clientIp,
									platform: ANTI_FRAUD.PLATFORM,
									appVersion: ANTI_FRAUD.APP_VERSION,
									blackbox: btoa(deviceBlackBox),
								},
							},
						},
						config
					),
				payload: { values, formId, isCaptcha: true },
			})
		})
		.then(
			(resp) => {
				const { token, returnAction } = resp.payload
				// store user details and jwt token in local storage to keep user logged in between page refreshes
				return Promise.resolve()
					.then(() => {
						const user = jwtDecode(token)
						return dispatch(setKeepLogin(user))
					})
					.then(() => {
						const decodedToken = jwtDecode(token)
						const expiredTimeToken = new Date(decodedToken.exp * 1000)
						setTokenCookie(JWT_TOKEN, token, expiredTimeToken)
						deleteCookie(NO_OF_TRIES)
						return Promise.resolve()
					})
					.then(() => {
						const currentLanguage = getActiveLanguage(getState().locale).code

						switch (returnAction) {
							case VERIFY_GOLD_CARD_ADDRESS:
								dispatch(
									push(
										`/${currentLanguage}/cards/verify-gold-card-address`
									)
								)
								break

							default:
								dispatch(
									push({
										pathname: `/${currentLanguage}/account`,
										state: { showTnC: true },
									})
								)
								break
						}

						return Promise.resolve()
					})
			},
			(error) => {
				increaseNoOfTries()
				return Promise.reject(error)
			}
		)
		.finally(() => {
			getDevicePayload()
		})
}
export const loadingLoginWithoutFormIdSelector = createLoadingSelector([LOGIN])
export const loginWithoutFormId = (values) => (dispatch, getState) => {
	const isFetching = loadingLoginSelector(getState())
	if (!values || isFetching) return Promise.resolve()

	return Promise.resolve()
		.then(() => dispatch(getToken()))
		.then(() =>
			dispatch({
				types: [LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE],
				callAPI: (config) =>
					apiClient.post(`api/account/authenticateRedemption`, values, config),
				payload: { values, isCaptcha: true },
			})
		)
		.then(
			(resp) => {
				const { token, returnAction } = resp.payload
				// store user details and jwt token in local storage to keep user logged in between page refreshes
				return Promise.resolve()
					.then(() => {
						const user = jwtDecode(token)
						return dispatch(setKeepLogin(user))
					})
					.then(() => {
						const decodedToken = jwtDecode(token)
						const expiredTimeToken = new Date(decodedToken.exp * 1000)
						setTokenCookie(JWT_TOKEN, token, expiredTimeToken)
						deleteCookie(NO_OF_TRIES)
						return Promise.resolve()
					})
					.then(() => {
						const currentLanguage = getActiveLanguage(getState().locale).code
						console.log(returnAction)

						switch (returnAction) {
							case VERIFY_GOLD_CARD_ADDRESS:
								dispatch(
									push(
										`/${currentLanguage}/cards/verify-gold-card-address`
									)
								)
								break
							case GOTO_ADD_CARD:
								dispatch(
									push({
										pathname: `/${currentLanguage}/cards/add-card`,
										state: { showTnC: true },
									})
								)
								break

							default:
								dispatch(
									push({
										pathname: `/${currentLanguage}/account`,
										state: { showTnC: true },
									})
								)
								break
						}

						return Promise.resolve()
					})
			},
			(error) => {
				increaseNoOfTries()
				return Promise.reject(error)
			}
		)
}

const increaseNoOfTries = () => {
	// store no of tries into cookie to show captcha even after page refreshes
	let noOfTries = getCookie(NO_OF_TRIES)
	noOfTries = noOfTries ? parseInt(noOfTries, 10) : 0
	//set captcha for 1 hours
	setCookie(NO_OF_TRIES, ++noOfTries, 1 / 24)
}

export const csoLoginMemberSelector = createLoadingSelector([CSO_LOGIN])
export const csoLoginMember = (token) => (dispatch, getState) => {
	const isFetching = csoLoginMemberSelector(getState())
	if (!token || isFetching) return Promise.resolve()

	return dispatch({
		types: [CSO_LOGIN_REQUEST, CSO_LOGIN_SUCCESS, CSO_LOGIN_FAILURE],
		callAPI: (config) => apiClient.post("api/account/csoLogin", token, config),
		payload: { token },
	}).then((resp) => {
		const { token, returnAction } = resp.payload
		// store user details and jwt token in local storage to keep user logged in between page refreshes
		return Promise.resolve()
			.then(() => {
				const user = jwtDecode(token)
				return dispatch(setKeepLogin(user))
			})
			.then(() => {
				const decodedToken = jwtDecode(token)
				const expiredTimeToken = new Date(decodedToken.exp * 1000)
				setTokenCookie(JWT_TOKEN, token, expiredTimeToken)
				deleteCookie(NO_OF_TRIES)
				return Promise.resolve()
			})
			.then(
				() => {
					const currentLanguage = getActiveLanguage(getState().locale).code

					switch (returnAction) {
						case VERIFY_GOLD_CARD_ADDRESS:
							dispatch(
								push(`/${currentLanguage}/cards/verify-gold-card-address`)
							)
							break

						default:
							dispatch(
								push({
									pathname: `/${currentLanguage}/account`,
									state: { showTnC: true },
								})
							)
							break
					}

					return Promise.resolve()
				},
				(error) => {
					increaseNoOfTries()
					return Promise.reject(error)
				}
			)
	})
}

const loadingRefreshTokenSelector = createLoadingSelector([LOGIN])
export const refreshToken = () => (dispatch, getState) => {
	const isFetching = loadingRefreshTokenSelector(getState())
	if (isFetching || !getState().auth.isAuthenticated) return Promise.resolve()

	return dispatch({
		types: [REFRESH_TOKEN_REQUEST, REFRESH_TOKEN_SUCCESS, REFRESH_TOKEN_FAILURE],
		callAPI: (config) => apiClient.get(`api/account/refreshToken`, config),
	}).then((resp) => {
		const { token } = resp.payload
		// store user details and jwt token in local storage to keep user logged in between page refreshes
		return Promise.resolve()
			.then(() => {
				const user = jwtDecode(token)
				return dispatch(setKeepLogin(user))
			})
			.then(() => {
				const decodedToken = jwtDecode(token)
				const expiredTimeToken = new Date(decodedToken.exp * 1000)
				setTokenCookie(JWT_TOKEN, token, expiredTimeToken)
				return Promise.resolve()
			})
	})
}

const requestLogout = () => (dispatch) => {
	dispatch({
		type: LOGOUT_REQUEST,
		payload: {
			isAuthenticated: true,
			errorMessage: "",
			successMessage: "",
		},
	})

	return Promise.resolve()
}

const receiveLogout = () => (dispatch) => {
	dispatch({
		type: LOGOUT_SUCCESS,
		payload: { isAuthenticated: false, errorMessage: "" },
	})

	return Promise.resolve()
}

export const logout = () => (dispatch, getState) => {
	if (!getState().auth.isAuthenticated) return Promise.resolve()

	return Promise.resolve()
		.then(() => dispatch(requestLogout()))
		.then(() => {
			dispatch({
				types: ["", "", ""],
				callAPI: (config) => apiClient.post(`api/account/Logout`, null, config),
			})
			deleteCookie(JWT_TOKEN)
			deleteCookie(NO_OF_TRIES)

			return Promise.resolve()
		})
		.then(() => dispatch(receiveLogout()))
}

export default function reducer(state = initialState, action) {
	const { errorMessage, payload } = action
	switch (action.type) {
		case SET_KEEP_LOGIN:
		case LOGOUT_REQUEST:
		case REFRESH_TOKEN_SUCCESS:
			return {
				...state,
				...payload,
			}
		case LOGOUT_SUCCESS:
		case LOGIN_REQUEST:
		case CSO_LOGIN_REQUEST:
			return {
				...state,
				token: "",
				isAuthenticated: false,
				keepLogin: false,
				errorMessage: "",
			}
		case LOGIN_SUCCESS:
		case CSO_LOGIN_SUCCESS:
			return {
				...state,
				...payload,
				isAuthenticated: true,
				noOfTries: 0,
			}
		case LOGIN_FAILURE:
		case CSO_LOGIN_FAILURE:
			return {
				...state,
				noOfTries: ++state.noOfTries,
				errorMessage,
			}
		case REFRESH_TOKEN_FAILURE:
			return {
				...state,
				errorMessage,
			}
		default:
			return state
	}
}
